<template>
    <div>
    <div class="hero">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="hero-content">
                        <h1 class="display-4 font-weight-bold  text-white">Dashboard</h1>
                        <h4 class="font-weight-light  text-white">{{`${ account ? account.name : ''}`}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <!--Boxes-->
        <span v-if="!isCropDrType">
        <div class="boxes-hero">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-6 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        {{this.sensor_name}}
                                    </div>
                                    <span style="font-weight: bold;margin-right:10px">{{this.podid}}</span>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <div class="row py-2" style="color: black">
                                    <div class="col-md-12">
                                        <div v-if="turnOverRate.retrieved && !dom_values_by_sensor_type.show_summary_ratio_buttons"
                                        style="font-size: 30px; font-weight: bold" class="d-flex align-items-center justify-content-center">
                                            {{dom_values_by_sensor_type.summary_label}}
                                        </div>
                                        <div v-if="dom_values_by_sensor_type.show_summary_ratio_buttons && turnOverRate.retrieved"
                                             class="d-flex align-items-center justify-content-center" style="margin-bottom: 0px">
                                            <b-form-radio-group
                                                    buttons
                                                    class="mt-3"
                                                    id="btn-radios-1"
                                                    name="radio-btn-outline"
                                                    button-variant="outline-primary"
                                                    :options="summary_buttons"
                                                    v-model="selected_summary_unit"
                                                    @input="update_summary_units"
                                            />
                                        </div>
                                        <div v-if="turnOverRate.retrieved" class="d-flex align-items-center justify-content-center">

                                            <!--CIRCLE-->
                                            <div style="width: 210px;
                                                        height: 210px;
                                                        background: #00A716;
                                                        border-radius: 110px;
                                                        margin-bottom: 4.0rem;
                                                        margin-top: 3.0rem">

                                                <!--HIGH-->
                                                <div style="margin-top: -25px; margin-right: -350px">
                                                    <table width="100%">
                                                        <tr><td><span style="margin-left: 120px; width: 5px; margin-top: 35px; border-radius: 5px; border: 5px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td><span style="margin-left: 120px; width: 100px; margin-top: 37px; border-bottom: 3px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td align="center" style="font-size: 40px;">{{ turnOverRate.high | parse_summary }}</td></tr>
                                                        <tr><td align="center" style="font-size: 18px; font-weight: bold; color: #296a9b">HIGH</td></tr>
                                                        <tr><td v-if="turnOverRate.high_date" align="center">{{ turnOverRate.high_date | formatDate}}</td></tr>
                                                        <tr><td v-if="!turnOverRate.high_date" align="center">&nbsp;</td></tr>
                                                    </table>
                                                </div>

                                                <!--CURRENT-->
                                                <div style="margin-top: -60px" class="d-flex align-items-center justify-content-center">
                                                    <table width="100%">
                                                        <tr><td align="center">
                                                            <span style="color: white; font-size: 70px; padding-bottom: -10px; margin-bottom: -10px">{{ turnOverRate.current | parse_summary }}</span>
                                                            <p style="margin-top: -15px; font-size: 20px; font-weight: bold; color: black">LATEST</p>
                                                        </td></tr>
                                                    </table>
                                                </div>

                                                <!--AVERAGE-->
                                                <div style="margin-top: -50px; margin-left: -350px;">
                                                    <table width="100%">
                                                        <tr><td><span style="margin-left: 380px; width: 5px; margin-top: 35px; border-radius: 5px; border: 5px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td><span style="margin-left: 342px; width: 45px; margin-top: 37px; border-bottom: 3px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td align="center" style="font-size: 40px;">{{ turnOverRate.avg | parse_summary }}</td></tr>
                                                        <tr><td align="center" style="font-size: 18px; font-weight: bold; color: #296a9b">AVERAGE</td></tr>
                                                        <tr><td align="center">{{fromDate | formatDate}} - {{toDate | formatDate}}</td></tr>
                                                    </table>
                                                </div>

                                                <!--LOW-->
                                                <div style="margin-top: -90px; margin-right: -350px;">
                                                    <table width="100%">
                                                        <tr><td><span style="margin-left: 120px; width: 5px; margin-top: 35px; border-radius: 5px; border: 5px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td><span style="margin-left: 120px; width: 100px; margin-top: 37px; border-bottom: 3px solid #DDD;position: absolute;"/></td></tr>
                                                        <tr><td align="center" style="font-size: 40px;">{{ turnOverRate.low | parse_summary }}</td></tr>
                                                        <tr><td align="center" style="font-size: 18px; font-weight: bold; color: #296a9b">LOW</td></tr>
                                                        <tr><td v-if="turnOverRate.low_date" align="center">{{ turnOverRate.low_date | formatDate}}</td></tr>
                                                        <tr><td v-if="!turnOverRate.low_date" align="center">&nbsp;</td></tr>
                                                    </table>
                                                </div>
                                            </div>

                                            <div v-if="!turnOverRate.retrieved" class="d-flex align-items-center justify-content-center form-loading" style="font-weight: bold; font-size: 30px; margin-top: 180px">
                                                <div class="text-center text-primary">
                                                    <b-spinner class="align-middle"></b-spinner>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">Learn More</div>
                            <div class="box-body p-3">
                                <a href="http://konametrix.com">
                                    <b-carousel
                                            id="carousel-1"
                                            v-model="slide"
                                            :interval="5000"
                                            background="#ababab"
                                            controls
                                            indicators
                                            @sliding-start="onSlideStart"
                                            @sliding-end="onSlideEnd"
                                    >
                                        <b-carousel-slide img-src="/help/slide1.png"></b-carousel-slide>
                                        <b-carousel-slide img-src="/help/slide2.png"></b-carousel-slide>
                                    </b-carousel>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
        <div class="boxes mb-4">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        Device List
                                    </div>
<!--                                    <div class="col text-right">-->
<!--                                        <button disabled class="btn btn-green btn-rounded" data-toggle="modal" data-target="#newDevice">-->
<!--                                            +Add Device-->
<!--                                        </button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <dashboard-table :userData="userData" @update_sensor="retrieve_sensor_data"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="boxes mb-4">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col-7">
                                        Sensor History - {{this.podid}}
                                    </div>
                                    <div class="col-5 text-right">
                                        <form @submit.prevent="update_graphs">
                                            <b-input-group>
                                                <date-picker style="width:120px" v-model="fromDate" :config="options" placeholder="fromDate"></date-picker>
                                                <date-picker style="width:120px; margin-left:5px" v-model="toDate" :config="options" placeholder="toDate"></date-picker>
                                                <b-btn style="margin-left:5px" type="submit">SEARCH</b-btn>
                                            </b-input-group>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <span v-if="water_level_summary_data">
                                    <dashboard-chart :chart_data="water_level_summary_data" chart_type="ColumnChart" graph_title="Water Level" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:-2,max:2}" graph_height="350"/>
                                    <dashboard-chart :chart_data="temperature_summary_data" chart_type="ColumnChart" graph_title="Temperature" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:30,max:130}" graph_height="350"/>
                                </span>
                                <span v-if="cropdr_temperature_data">
                                    <dashboard-chart :chart_data="cropdr_temperature_data" chart_type="LineChart" graph_title="Temperature" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:130}" graph_height="350"/>
                                </span>
                                <span v-if="cropdr_par_data">
                                    <dashboard-chart :chart_data="cropdr_par_data" chart_type="LineChart" graph_title="SPI Level" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:1800000}" graph_height="350"/>
                                </span>
                                <span v-if="cropdr_rgbwir_data">
                                    <dashboard-chart :chart_data="cropdr_rgbwir_data" chart_type="LineChart" graph_title="RGBWIR" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:20000}" graph_height="350"/>
                                </span>
                                <span v-if="cropdr_moisture_data">
                                    <dashboard-chart :chart_data="cropdr_moisture_data" chart_type="LineChart" graph_title="Soil Moisture" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:130}" graph_height="350"/>
                                </span>
                                <span v-if="cropdr_vpd_data">
                                    <dashboard-chart :chart_data="cropdr_vpd_data" chart_type="LineChart" graph_title="VPD" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:130}" graph_height="350"/>
                                </span>
                                <!-- <span v-if="cropdr_vpd_humidity_data">
                                    <dashboard-chart :chart_data="cropdr_vpd_humidity_data" chart_type="LineChart" graph_title="VPD/Humidity" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:130}" graph_height="350"/>
                                </span> -->
                                <span v-if="cropdr_humidity_data">
                                    <dashboard-chart :chart_data="cropdr_humidity_data" chart_type="LineChart" graph_title="Humidity" :loading="loading" date_format="MM/dd"
                                                     :view_window="{min:0,max:130}" graph_height="350"/>
                                </span>

                                <dashboard-chart v-if="sensor_data" :chart_data="sensor_data" :chart_type="dom_values_by_sensor_type.chart_type" :chart_legend="dom_values_by_sensor_type.legend"
                                               :graph_title="dom_values_by_sensor_type.summary_label" :loading="loading" date_format="MM/dd"
                                               :view_window="dom_values_by_sensor_type.axis_window" graph_height="500"/>

                                <dashboard-chart v-if="gallons_added_data" :chart_data="gallons_added_data" chart_type="ColumnChart" graph_height="350"
                                                 graph_title="Times Filled & Gallons Added By Date" :loading="loading" date_format="MM/dd"/>

                                <div v-if="stored_summary" class="d-flex align-items-center justify-content-center" style="color:black; font-size: 22px; margin: 30px">
                                    <span v-if="stored_summary == null">Water was called 0 times in the last 24 hours.</span>
                                    <span v-if="stored_summary.numberOfFills && stored_summary.numberOfFills.avg != null ">Water was called {{stored_summary.numberOfFills.avg}} time(s) on average
                                      during this time period.</span>
                                    <span v-else>Water was called {{stored_summary.numberOfFills}} time(s) in the last 24 hours.</span>
                                </div>

                                <div v-if="stored_summary" class="d-flex align-items-center justify-content-center" style="color:black; font-size: 22px; margin: 30px">
                                    <span>Your fill flow rate = {{gpm}} GPM - Click <b-link id="update-gpm-link" @click="show_update_gpm">here</b-link> to change the fill rate
                                    </span>
                                </div>

                                <div v-if="update_gpm_displayed" class="d-flex align-items-center justify-content-center" style="font-size: 16px" >
                                    <b-form @submit.prevent="update_gpm" style="color:black; font-size: 18px">
                                        <table cellpadding="10">
                                            <tr>
                                                <td>GPM (Gallons Per Minute - Used To Estimate Gallons Added)</td>
                                                <td><b-form-input v-model="gpm" type="text" /></td>
                                                <td><b-button type="submit" variant="dark">Update GPM</b-button></td>
                                            </tr>
                                        </table>
                                    </b-form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

     <div class="boxes mb-4">
        <span v-if="!isCropDrType">  
        <div class="container">
          <div class="row equal">
            <div class="col-md-12 my-2">
              <div class="box shadow-lg bg-white rounded">
                <div class="box-header bg-light-blue p-3">
                  <div class="row">
                    <div class="col-5">
                      Sensor Data Details - {{this.podid}}
                    </div>
                    <div class="col-3" style="font-weight: bold; font-size:24px">
                      <span v-if="resolution == 'daily'">
                       DAY &nbsp;|&nbsp;<a href="#" class="gray-link" v-on:click.prevent="update_resolution()">WEEK</a>
                      </span>
                      <span v-else>
                        <a href="#" class="gray-link" v-on:click.prevent="update_resolution()">DAY</a>&nbsp;|&nbsp;WEEK
                      </span>
                    </div>
                    <div v-if="resolution == 'daily'" class="col-4 align-right d-flex align-items-center justify-content-center">
                      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
                      &nbsp;&nbsp;<date-picker style="width:120px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
                      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
                    </div>
                    <div v-else class="col-4 align-right d-flex align-items-center justify-content-center">
                      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><<</a>
                      &nbsp;&nbsp;<date-picker style="width:120px" v-model="details_toDate" :config="options" :placeholder="details_toDate"></date-picker>&nbsp;&nbsp;
                      <!-- &nbsp;&nbsp;{{details_fromDate | formatDate}} - {{details_toDate | formatDate}}&nbsp;&nbsp; -->
                      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">>></a>
                    </div>
                  </div>
                </div>
                <div class="box-body p-3">
                    <span v-if="water_level_summary_data">
                          <dashboard-chart :chart_data="water_level_detail_data" chart_type="LineChart" graph_title="Water Level" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:-2,max:2}" graph_height="350" />
                          <dashboard-chart :chart_data="temperature_detail_data" chart_type="LineChart" graph_title="Temperature" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:30,max:130}" graph_height="350" />
                    </span>
                    <span v-else>
                      <dashboard-chart v-if="chart_data" :chart_data="chart_data" chart_type="LineChart"
                                       :view_window="dom_values_by_sensor_type.details_axis_window"
                                       :graph_title="dom_values_by_sensor_type.chart_title" :loading="loading_detail" :date_format="detail_date_format" graph_height="500"
                      />
                        <div v-if="show_chart_data" class="text-center">
                          <div style="margin-top: 40px" v-if="!loading_detail && !chart_data">
                            <h3>-no data available-</h3>
                          </div>
                          <div v-if="loading_detail" style="height:150px; margin-top:260px">
                            <div class="text-center text-primary">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong style="margin-left:20px">Loading...</strong>
                            </div>
                          </div>
                        </div>

                      <dashboard-chart v-if="flow_plot_data" :chart_data="flow_plot_data" chart_type="LineChart" :chart_legend="{position: 'none'}"
                                       graph_desc="This flow rate is actually the speed of rotation of your water meter and relative to GPM flow. This graph shows times of the day when flow rates are higher than others."
                                       graph_title="Relative Flow Rate" :loading="loading_detail" :date_format="detail_date_format" :view_window="{min:0,max:30}"
                                       graph_height="500" />
                      <div v-if="show_flow_plot_data" class="text-center">
                        <div style="margin-top: 40px" v-if="!loading_detail && !flow_plot_data">
                          <h3>-no data available-</h3>
                        </div>
                        <div v-if="loading_detail" style="height:150px; margin-top:260px">
                          <div class="text-center text-primary">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong style="margin-left:20px">Loading...</strong>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span v-if="cropdr_temperature_chart_data">                
                          <dashboard-chart :chart_data="cropdr_temperature_chart_data" chart_type="LineChart" graph_title="Temperature" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:130}" graph_height="350" />
                    </span>
                    <span v-if="cropdr_rgbwir_chart_data">
                          <dashboard-chart :chart_data="cropdr_rgbwir_chart_data" chart_type="LineChart" graph_title="RGBWIR" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:20000}" graph_height="350" />
                    </span>
                    <span v-if="cropdr_par_chart_data">
                          <dashboard-chart :chart_data="cropdr_par_chart_data" chart_type="LineChart" graph_title="SPI Level" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:1800000}" graph_height="350" />
                    </span>
                    <span v-if="co2_chart_data">                
                          <dashboard-chart :chart_data="co2_chart_data" chart_type="LineChart" graph_title="CO2 Level" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:1600}" graph_height="350" />
                    </span>
                    <span v-if="cropdr_moisture_chart_data">                
                          <dashboard-chart :chart_data="cropdr_moisture_chart_data" chart_type="LineChart" graph_title="Soil Moisture" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:100}" graph_height="350" />
                    </span>
                    <span v-if="vpd_chart_data">                
                          <dashboard-chart :chart_data="vpd_chart_data" chart_type="LineChart" graph_title="VPD" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:130}" graph_height="350" />
                    </span>
                    <!-- <span v-if="vpd_humidity_chart_data">                
                          <dashboard-chart :chart_data="vpd_humidity_chart_data" chart_type="LineChart" graph_title="VPD/Humidity" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:130}" graph_height="350" />
                    </span> -->
                    <span v-if="humidity_chart_data">                
                          <dashboard-chart :chart_data="humidity_chart_data" chart_type="LineChart" graph_title="Humidity" :loading="loading_detail"
                                           :date_format="detail_date_format" :view_window="{min:0,max:130}" graph_height="350" />
                    </span>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
      </div>
    </div>
</template>

<script>
    import {justDate} from '../../helpers/dates'
    import DashboardTable from './DashboardTable'
    import DashboardChart from './DashboardChart'
    import { GChart } from 'vue-google-charts'
    import moment from 'moment'
    import { admin_methods } from '../../networking/account'
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import 'font-awesome/css/font-awesome.css';
    import { adjustDate } from '../../helpers/dates'

    import {
        get_sensor_summary,
        get_sensor_data,
        get_cropdr_sensor_data,
        get_sensor_flow_plot,
        update_sensor_gpm, get_hourly_sensor_summary_bydate
    } from '../../networking/devices'

    import {
        Wireless_Liquid_Level_Sensor,
        Single_Wired_Pressure_Sensor,
        Dual_Wired_Pressure_Sensor,
        Wired_Mag_Field_XYZ,
        FlowVis_Digital,
        KonaFlow_Digital,
        Grow3D_Sensor_III,
        Grow3D_Sensor_II,
        device_type_enum,
    } from '../../helpers/devices'

    const capitalize = value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase() : ''

    const flowVis_dom_values = {
        summary_label: 'Total Flow Per Day',
        chart_title: 'Flow Rate',
        chart_type: 'ColumnChart',
        unit_of_measure: 'GPM',
        //axis_window: { max: 10, min: 0 },
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716'],
        show_summary_ratio_buttons: false,
        extra_chart_series: {},
        extra_axes: null
    }

    const konaFlow_dom_values = {
        summary_label: 'Flow Rate',
        chart_title: 'Flow Rate',
        chart_type: 'ColumnChart',
        unit_of_measure: 'GPM',
        axis_window: { max:30, min:0 },
        details_axis_window: { max:30, min:0 },
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
        show_summary_ratio_buttons: false,
        extra_chart_series: {},
        extra_axes: null
    }

    const meterDog_dom_values = {
        summary_label: 'WaterNumber',
        chart_type: 'ColumnChart',
        chart_title: 'WaterNumber\u2122',
        chart_title_help: 'WaterNumber is generated by the WaterMetrix algorithm and is unique to your water use and infrastructure. Trending WaterNumbers help water efficiency and alert to high use and activity day to day.',
        unit_of_measure: 'WaterNumber',
        axis_window: { max: 60, min: 0 },
        details_axis_window: { max:30, min:0 },
        show_chart_ratio_buttons: false,
        chart_line_colors: ['#296a9b'],
        show_summary_ratio_buttons: false,
        extra_chart_series: {},
        extra_axes: null
    }

    const single_pressure_dom_values = {
        summary_label: 'Water Pressure',
        chart_title: 'Water Pressure',
        chart_type: 'ColumnChart',
        unit_of_measure: 'PSI',
        axis_window: { min:0, max: 250 },
        details_axis_window: { min:0, max: 250 },
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
        show_summary_ratio_buttons: false,
        extra_chart_series: {},
        extra_axes: null
    }

    const dual_pressure_dom_values = {
      summary_label: 'Dual Water Pressure',
      chart_title: 'Dual Water Pressure',
      chart_type: 'ColumnChart',
      unit_of_measure: 'PSI',
      //axis_window: { min:0, max: 250 },
      //details_axis_window: { min:0, max: 250 },
      show_chart_ratio_buttons: true,
      chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
      show_summary_ratio_buttons: false,
      extra_chart_series: {},
      extra_axes: null
    }

    const levelSmart_dom_values = {
//        legend: "{ position: 'top', alignment: 'center', textStyle: {color: 'black'} }",
        summary_label: 'Inches',
        chart_type: 'LineChart',
        chart_title: 'Water Level',
        unit_of_measure: 'Inches',
        //axis_window: {max: 105, min: 50},
        //details_axis_window: {max: 105, min: 50},
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
        show_summary_ratio_buttons: true,
        extra_chart_series:{ 1:{ targetAxisIndex: 1 }},
        extra_axes:{ 1: {title: 'Fahrenheit' }}
    }

    const cropdr_co2_dom_values = {
//        legend: "{ position: 'top', alignment: 'center', textStyle: {color: 'black'} }",
        summary_label: 'CO2 PPM',
        chart_type: 'LineChart',
        chart_title: 'CO2 Level',
        unit_of_measure: 'PPM',
        axis_window: {max: 1600, min: 100},
        //details_axis_window: {max: 1605, min: 150},
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
        //show_summary_ratio_buttons: true,
        extra_chart_series:{ 1:{ targetAxisIndex: 1 }},
        extra_axes:{ 1: {title: 'PPM' }}
    }

    const cropdr_par_dom_values = {
    //    legend: "{ position: 'top', alignment: 'center', textStyle: {color: 'black'} }",
        summary_label: 'SPI Level',
        chart_type: 'LineChart',
        chart_title: 'SPI Level',
        unit_of_measure: 'calculation',
        axis_window: {max: 1800000, min: 0},
        //details_axis_window: {max: 1605, min: 150},
        show_chart_ratio_buttons: true,
        chart_line_colors: ['#296a9b', '#00a716', 'darkred'],
        //show_summary_ratio_buttons: true,
        extra_chart_series:{ 1:{ targetAxisIndex: 1 }},
        extra_axes:{ 1: {title: 'SPI' }}
    }

    const inches = 'inches'
    const fahrenheit = 'fahrenheit'
    const summary_buttons = [
        { text: 'Water Level', value: inches },
        { text: 'Temperature', value: fahrenheit }
    ]

    const compute_alert_duration = ({ status, startDateTime, endDateTime }) => status === 'OPEN'
        ?   moment.duration(moment(startDateTime).diff(moment(new Date))).humanize()
        :   moment.duration(moment(startDateTime).diff(moment(endDateTime))).humanize()

    export default {
        props:{ userData:{ type: Object, required: true } },

        components:{
            DashboardTable,
            DashboardChart,
            GChart,
            datePicker
        },

        data(){
            return {
                slide: 0,
                sliding: null,

                options: {
                    format: 'MM/DD/YYYY',
                    useCurrent: true,
                    minDate: moment().subtract(90, 'days'),
                    maxDate: moment().add(1, 'hours'),
                    keepOpen: false,
                    showClear: true,
                    showClose: true,
                    //toolbarPlacement: 'top',
                },
                moment: moment,
                resolution: 'daily',
                detail_date_format: 'hhaa',
                sensor_data: null,
                chart_data: null,
                water_number_data: null,
                water_level_summary_data: null,
                temperature_summary_data: null,
                water_level_detail_data: null,
                temperature_detail_data: null,
                cropdr_par_data: null,
                cropdr_par_chart_data: null,
                cropdr_rgbwir_data: null,
                cropdr_rgbwir_chart_data: null,
                cropdr_temperature_data: null,
                cropdr_temperature_chart_data: null,
                co2_chart_data: null,
                co2_data: null,
                cropdr_moisture_data: null,
                cropdr_moisture_chart_data: null,
                cropdr_vpd_data: null,
                vpd_chart_data: null,
                cropdr_vpd_humidity_data: null,
                vpd_humidity_chart_data: null,
                cropdr_humidity_data: null,
                humidity_chart_data: null,
                flow_plot_data: null,
                show_flow_plot_data: false,
                show_chart_data: false,
                fromDate: moment().subtract(7, 'days'),
                toDate: moment(),
                details_fromDate: justDate(moment().subtract(8,'hours')),
                details_toDate: justDate(moment().add(12,'hours')),
                gallons_added_data: null,

                selected_summary_unit: inches,
                summary_buttons: summary_buttons,

                radio_buttons: null,
                isCropDrType: null,

                turnOverRate: {
                    retrieved: false,
                    high: null,
                    high_date: null,
                    low: null,
                    low_date: null,
                    avg: null,
                    current: null
                },

                loading: true,
                loading_detail: true,
                sensor_name: null,
                podid: null,
                imei: null,
                gpm: 10,
                update_gpm_displayed: false,
                sensor_type_desc: null,
                alert_profiles: null,
                chart_threshold: null,
                service_plan_name: 'Basic',

                dom_values_by_sensor_type:{
                    legend: {position: 'none'},
                    summary_label: '',
                    chart_type: 'LineChart',
                    chart_title: '',
                    unit_of_measure: '',
                    axis_window: { max:100, min:0 },
                    details_axis_window: null,
                    show_chart_ratio_buttons: null
                },

                stored_summary: null,
                stored_chartData: null,
                account: null
            }
        },

        async created(){
            this.get_account()
        },

        methods:{
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            },
            async get_account(){
                const admin_generator = admin_methods.get_account(this.userData.accountId)
                const { value: { data }} = await admin_generator.next()
                this.account = data
            },
            async update_graphs(){
                this.retrieve_sensor_data({imei: this.imei, podid: this.podid, sensor_type_desc: this.sensor_type_desc, gpm: this.gpm, sensor_name: this.sensor_name})
            },
            reset_chart_data: function () {
                this.loading = true
                this.loading_detail = true
                this.flow_plot_data = null
                this.show_flow_plot_data = false
                this.show_chart_data = false
                this.gallons_added_data = null
                this.stored_summary = null
                this.stored_chartData = null
                this.sensor_data = null
                this.chart_data = null
                this.water_level_summary_data= null
                this.temperature_summary_data= null
                this.water_level_detail_data= null
                this.temperature_detail_data= null
                this.co2_data = null
                this.cropdr_moisture_data = null
                this.cropdr_par_chart_data = null
                this.cropdr_rgbwir_chart_data = null
                this.cropdr_vpd_data = null
                this.cropdr_vpd_humidity_data = null
                this.cropdr_par_data = null
                this.cropdr_rgbwir_data = null
                this.cropdr_humidity_data = null
                this.co2_chart_data = null
                this.cropdr_moisture_chart_data = null
                this.cropdr_temperature_data = null
                this.cropdr_temperature_chart_data = null
                this.vpd_chart_data = null
                this.vpd_humidity_chart_data = null
                this.humidity_chart_data = null
            },
            async retrieve_sensor_data({imei, podid, sensor_type_desc, gpm, sensor_name, service_plan_name}) {
                //  console.log("retrieve_sensor_data: imei: " + imei + " sensorId: " + podid + " sensor_type_desc: " + sensor_type_desc +
                //      " gpm: " + gpm + " sensor_name: " + sensor_name + " service_plan_name: " + service_plan_name);
                // this.reset_chart_data();
                this.turnOverRate = {...this.turnOverRate, retrieved: false}
                this.gpm = gpm
                if (sensor_name != null)
                    this.sensor_name = sensor_name;
                this.podid = podid
                this.imei = imei
                this.service_plan_name = service_plan_name
                this.sensor_type_desc = sensor_type_desc
                this.isSensorCropDrType()
                //console.log('sensor type: ' + sensor_type_desc)
                //console.log('sensor type enum: ' + device_type_enum[this.sensor_type_desc])
                if (device_type_enum[this.sensor_type_desc] === FlowVis_Digital) {
                    this.dom_values_by_sensor_type = flowVis_dom_values
                    this.retrieve_flowvis_data()
                    this.retrieve_flowvis_chart_data()
                } else if (device_type_enum[this.sensor_type_desc] === Wired_Mag_Field_XYZ) {
                    this.dom_values_by_sensor_type = meterDog_dom_values
                    this.retrieve_meter_dog_data()
                    this.retrieve_flow_plot_data()
                } else if (device_type_enum[this.sensor_type_desc] === Wireless_Liquid_Level_Sensor) {
                    this.dom_values_by_sensor_type = levelSmart_dom_values
                    this.retrieve_level_smart_data()
                    this.set_lsol_chart_data()
                } else if (device_type_enum[this.sensor_type_desc] === Single_Wired_Pressure_Sensor) {
                  this.dom_values_by_sensor_type = single_pressure_dom_values
                  this.retrieve_wired_pressure_data()
                  this.retrieve_wired_pressure_data_details()
                } else if (device_type_enum[this.sensor_type_desc] === Dual_Wired_Pressure_Sensor) {
                  this.dom_values_by_sensor_type = dual_pressure_dom_values
                  this.retrieve_dual_wired_pressure_data()
                  this.retrieve_dual_wired_pressure_data_details()
                } else if (device_type_enum[this.sensor_type_desc] === KonaFlow_Digital){
                    this.dom_values_by_sensor_type = konaFlow_dom_values
                    this.retrieve_konaflow_data()
                    this.set_konaflow_chart_data()
                } else if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III) {
                    this.dom_values_by_sensor_type = cropdr_co2_dom_values
                    this.retrieve_cropdr_sensorIII_data()
                    // this.retrieve_cropdr_co2_data()
                    // this.set_cropdr_chart_co2_data()
                } else if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_II) {
                    this.dom_values_by_sensor_type = cropdr_par_dom_values
                    this.retrieve_cropdr_sensorII_data()
                    // this.retrieve_cropdr_par_data()
                    // this.set_cropdr_par_chart_data()
                }
                else {
                    // TO DO. Implement logging and reporting on the client:  https://logrocket.com/
                }
            },
            async isSensorCropDrType() {
                if ((device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_II) ||
                 (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III)) {
                    this.isCropDrType = true
                    return true
                 }
                 this.isCropDrType = false
                 return false
            },
            async retrieve_cropdr_sensorI_data() {

            },
            async retrieve_cropdr_sensorII_data() {
                this.set_cropdr_rgbwir_data()
                this.set_cropdr_rgbwir_chart_data()
                this.set_cropdr_moisture_data()
                this.set_cropdr_temperature_data()
                this.set_cropdr_chart_temperature_data()
                this.set_cropdr_chart_moisture_data()
            },
            async retrieve_cropdr_sensorIII_data() {
                this.retrieve_cropdr_co2_data()
                //this.retrieve_cropdr_par_data()
                this.set_cropdr_par_data()
                this.set_cropdr_temperature_data()
                this.set_cropdr_moisture_data()
                this.set_cropdr_chart_co2_data()
                this.set_cropdr_par_chart_data()
                this.set_cropdr_chart_temperature_data()
                this.set_cropdr_chart_moisture_data()
                this.set_cropdr_vpd_data()
                this.set_cropdr_chart_vpd_data()
                this.set_cropdr_humidity_data()
                this.set_cropdr_chart_humidity_data()
                // this.set_cropdr_vpd_humidity_data()
                // this.set_cropdr_chart_vpd_humidity_data()
            },
            async retrieve_cropdr_sensorIV_data() {

            },
            async retrieve_cropdr_co2_data() {
                this.co2_data = null

                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "CO2_LEVEL"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
                if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III) {
                    this.co2_data = [

                    ]
                    if (data[0]) {
                        this.sensor_data = [
                            ['Date', 'CO2 Level'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
                }
            },
            async set_cropdr_par_data() {
                this.loading_detail = false

                this.cropdr_par_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "PAR_NUMBER"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
                if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III) {
                    this.cropdr_par_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_par_data = [
                            ['Date', 'SPI Level'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
                }

                this.loading_detail = false
            },
            async set_cropdr_chart_co2_data() {
              this.loading_detail = true
              this.co2_chart_data = null

              if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III) {
                const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "CO2_LEVEL"
                })
                const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
                if (data[0]) {
                  this.co2_chart_data = [
                    ['Date', 'CO2 Level'],
                    ...data.map(({date, value}) => [
                      new Date(date),
                      Number(value)
                    ])
                  ]
                }
                this.loading_detail = false
                }
            },
            async retrieve_cropdr_par_data() {
                this.par_data = null

                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "PAR_NUMBER"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()

                if ((device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_II) ||
                    (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III)) {
                    this.par_data = [

                    ]
                    if (data[0]) {
                        this.sensor_data = [
                            ['Date', 'SPI Level'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
                }

                this.loading_detail = false
            },
            async set_cropdr_par_chart_data() {
              this.loading_detail = true
              //this.chart_data = null
              this.cropdr_par_chart_data = null

              if ((device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_II) ||
                    (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III)) {
                const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "PAR_NUMBER"
                })
                const { value: { data = [] } } = await sensor_data_generator.next()
                if (data[0]) {
                  this.cropdr_par_chart_data = [
                    ['Date', 'SPI Level'],
                    ...data.map(({date, value}) => [
                      new Date(date),
                      Number(value)
                    ])
                  ]
                }
                this.loading_detail = false
                }
            },
            async set_cropdr_temperature_data() {
                this.loading_detail = false

                this.cropdr_temperature_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "TEMPERATURE"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.cropdr_temperature_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_temperature_data = [
                            ['Date', 'Degrees'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_chart_temperature_data() {
              this.loading_detail = true
              this.cropdr_temperature_chart_data = null
              //this.chart_data = null

 //             if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "TEMPERATURE"
                })
                const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
                if (data[0]) {
                  this.cropdr_temperature_chart_data = [
                    ['Date', 'Degrees'],
                    ...data.map(({date, value}) => [
                      new Date(date),
                      Number(value)
                    ])
                  ]
                }
                this.loading_detail = false
                //this.set_cropdr_par_chart_data()
//                }
            },
            async retrieve_cropdr_moisture_data() {
                this.cropdr_moisture_data = null

                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "Moisture"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.moisture_data = [

                    ]
                    // if (data[0]) {
                    //     this.sensor_data = [
                    //         ['Date', 'Soil Moisture Percent'],
                    //         ...data.map(({ date, value }) => [
                    //             new Date(date),
                    //             Number(value)
                    //         ])
                    //     ]
                    // }
                    if (data[0]) {
                        this.sensor_data = [
                            ['Date', 'Soil Moisture Level'],
                            ...data.map(({ date, current }) => [
                                new Date(date),
                                Number(current)
                            ])
                        ]
                    }
                    this.loading = false
//                }
            },
            async set_cropdr_moisture_data() {
                this.loading_detail = false

                this.cropdr_moisture_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "MOISTURE_LEVEL"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.cropdr_moisture_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_moisture_data = [
                            ['Date', 'Current Level'],
                            ...data.map(({ date, current}) => [
                                new Date(date),
                                Number(current)
                            ])
                        ]
                    }
                    // if (data[0]) {
                    //     this.cropdr_moisture_data = [
                    //         ['Date', 'Soil Moisture Level', 'Set Level', 'Calc value'],
                    //         ...data.map(({ date, current, set, value }) => [
                    //             new Date(date),
                    //             Number(current),
                    //             Number(set),
                    //             Number(value)
                    //         ])
                    //     ]
                    // }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_chart_moisture_data() {
              this.loading_detail = true
              this.cropdr_moisture_chart_data = null

              const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "MOISTURE_LEVEL"
                })
              const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
              if (data[0]) {
                  this.cropdr_moisture_chart_data = [
                    ['Date', 'Current Level'],
                    ...data.map(({date, current}) => [
                      new Date(date),
                      Number(current)
                    ])
                  ]
                }
              this.loading_detail = false
            },
            async set_cropdr_vpd_data() {
                this.loading_detail = false

                this.cropdr_vpd_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "VPD"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.cropdr_vpd_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_vpd_data = [
                            ['Date', 'kPa'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_chart_vpd_data() {
              this.loading_detail = true
              this.vpd_chart_data = null

              const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "VPD"
                })
              const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
              if (data[0]) {
                  this.vpd_chart_data = [
                    ['Date', 'kPa'],
                    ...data.map(({date, value}) => [
                      new Date(date),
                      Number(value)
                    ])
                  ]
                }
              this.loading_detail = false
            },
            async set_cropdr_humidity_data() {
                this.loading_detail = false

                this.cropdr_humidity_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "HUMIDITY"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.cropdr_humidity_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_humidity_data = [
                            ['Date', 'percent'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_chart_humidity_data() {
              this.loading_detail = true
              this.humidity_chart_data = null

              const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "HUMIDITY"
                })
              const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
              if (data[0]) {
                  this.humidity_chart_data = [
                    ['Date', 'percent'],
                    ...data.map(({date, value}) => [
                      new Date(date),
                      Number(value)
                    ])
                  ]
                }
              this.loading_detail = false
            },
            async set_cropdr_vpd_humidity_data() {
                this.loading_detail = false

                this.cropdr_vpd_humidity_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "VPD_HUMIDITY"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
//                if (device_type_enum[this.sensor_type_desc] === CropDRx_Sensor_III) {
                    this.cropdr_vpd_humidity_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_vpd_humidity_data = [
                            ['Date', 'kPa','percent'],
                            ...data.map(({ date, vpd, humidity }) => [
                                new Date(date),
                                Number(vpd),
                                Number(humidity)
                            ])
                        ]
                    }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_rgbwir_data() {
                this.loading_detail = false

                this.cropdr_rgbwir_data = null
                const sensor_data_generator = get_cropdr_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.fromDate),
                    toDate: adjustDate(this.toDate),
                    cropDrType: "RGBWIR"
                })

                const { value: { data = [] } } = await sensor_data_generator.next()
                    this.cropdr_rgbwir_data = [

                    ]
                    if (data[0]) {
                        this.cropdr_rgbwir_data = [
                            ['Date', 'blue','red','infrared','white','green'],
                            ...data.map(({ date, blue, red, infrared, white, green }) => [
                                new Date(date),
                                Number(blue),
                                Number(red),
                                Number(infrared),
                                Number(white),
                                Number(green)
                            ])
                        ]
                    }
                    this.loading = false
//                }

                this.loading_detail = false
            },
            async set_cropdr_chart_vpd_humidity_data() {
              this.loading_detail = true
              this.vpd_humidity_chart_data = null

              const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "VPD_HUMIDITY"
                })
              const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
              if (data[0]) {
                  this.vpd_humidity_chart_data = [
                    ['Date', 'kPa','percent'],
                    ...data.map(({date, vpd, humidity}) => [
                      new Date(date),
                      Number(vpd),
                      Number(humidity)
                    ])
                  ]
                }
              this.loading_detail = false
            },
            async set_cropdr_rgbwir_chart_data() {
              this.loading_detail = true
              this.cropdr_rgbwir_chart_data = null

              const sensor_data_generator = get_cropdr_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  toDate: adjustDate(this.details_toDate),
                  cropDrType: "RGBWIR"
                })
              const { value: { data = [] } } = await sensor_data_generator.next()
                //console.log("data: " + data + "value: " + value)
              if (data[0]) {
                  this.cropdr_rgbwir_chart_data = [
                    ['Date', 'blue','red','infrared','white','green'],
                    ...data.map(({date, blue, red, infrared, white, green}) => [
                      new Date(date),
                      Number(blue),
                      Number(red),
                      Number(infrared),
                      Number(white),
                      Number(green)
                    ])
                  ]
                }
              this.loading_detail = false
            },
            async retrieve_flowvis_data() {
              this.chart_data = null

              const sensor_summary_generator = get_sensor_summary(
                  {
                    podId: this.podid,
                    fromDate: justDate(this.fromDate),
                    toDate: justDate(this.toDate)
                  });
              const {value: {data = []}} = await sensor_summary_generator.next()

              if (device_type_enum[this.sensor_type_desc] === FlowVis_Digital) {
                const {summary = {turnOverRate: {}}, daily = [{calculations: {totalFlow: 0}}]} = data
                this.turnOverRate = {
                  retrieved: true,
                  ...(summary.totalFlow || {high: 0, high_date: null, low: 0, low_date: null, avg: 0}),
                  current: daily.length !== 0
                      ? String((daily[daily.length - 1]).calculations.totalFlow) : 0
                }

                this.sensor_data = [
                  ['Date', 'Total Flow'],
                  ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                      ({date, calculations = {}}) => [
                        moment(String(date)).format('MM/DD'), Number(calculations.totalFlow || 0)
                      ]
                  )
                ]
                this.loading = false
              }
            },
            async retrieve_flowvis_chart_data() {
                this.loading_detail = true
                this.show_chart_data = true
                this.chart_data = null

                if (this.details_toDate) {
                    console.log('get flowvis chart data:get_sensor_data, fromDate: ' + 
                    adjustDate(this.details_fromDate) + ' toDate: ' + adjustDate(this.details_toDate))
                } else {
                    console.log('get flowvis chart data:get_sensor_data, fromDate: ' + 
                    adjustDate(this.details_fromDate))
                }

                if (this.details_toDate) {
                    const sensor_data_generator = get_sensor_data({
                        podid: this.podid,
                        fromDate: adjustDate(this.details_fromDate),
                        toDate: adjustDate(this.details_toDate)
                    })
                    const { value: { data = [] } } = await sensor_data_generator.next()
                    if (data[0]) {
                        this.chart_data = [
                            ['Date', 'GPM'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading_detail = false
                } else {
                    const sensor_data_generator = get_sensor_data({
                        podid: this.podid,
                        fromDate: adjustDate(this.details_fromDate),
                        //toDate: adjustDate(this.details_toDate)
                    })
                    const { value: { data = [] } } = await sensor_data_generator.next()
                    if (data[0]) {
                        this.chart_data = [
                            ['Date', 'GPM'],
                            ...data.map(({ date, value }) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                    }
                    this.loading_detail = false
                }

            },

            async set_konaflow_chart_data(){
                this.loading_detail = true
                this.show_chart_data = true
                this.chart_data = null

                const sensor_data_generator = get_sensor_data({
                    podid: this.podid,
                    fromDate: adjustDate(this.details_fromDate),
                    //toDate: adjustDate(this.details_toDate)
                })

                const { value: { data = [] } } = await sensor_data_generator.next()

                if (device_type_enum[this.sensor_type_desc] === KonaFlow_Digital) {
                    if (data[0]) {

                        this.chart_data = [
                            ['Date', 'GPM'],
                            ...data.map(({date, value}) => [
                                new Date(date),
                                Number(value)
                            ])
                        ]
                        this.turnOverRate.current = data[0].value
                    }
                    this.loading_detail = false
                }
            },
            async retrieve_konaflow_data(){

                const sensor_summary_generator = get_sensor_summary(
                    {
                        podId: this.podid,
                        fromDate: justDate(this.fromDate),
                        toDate: justDate(this.toDate)
                    });

                const {value: {data = {}}} = await sensor_summary_generator.next()
                const {summary = {}, daily = []} = data

                if (device_type_enum[this.sensor_type_desc] === KonaFlow_Digital) {
                    this.sensor_data = [
                        ['Date', 'Hi', 'Low', 'Average'],
                        ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date), Number(calculations.hiFlow), Number(calculations.lowFlow), Number(calculations.avgFlow)
                            ]
                        )
                    ]

                    if (summary != null && summary.hiFlow != null) {
                        this.turnOverRate = {
                            retrieved: true,
                            high: summary.hiFlow.high,
                            high_date: summary.hiFlow.high_date,
                            low: summary.lowFlow.low,
                            low_date: summary.lowFlow.low_date,
                            avg: summary.avgFlow.avg,
                            current: daily.length !== 0 ? String(daily[daily.length - 1].calculations.avgFlow) : 0
                        }
                    }
                    this.loading = false
                } else {

                }
            },
            async retrieve_wired_pressure_data() {
              this.show_chart_data = true

              const sensor_summary_generator = get_sensor_summary(
                  {
                    podId: this.podid,
                    fromDate: justDate(this.fromDate),
                    toDate: justDate(this.toDate)
                  });
              const {value: {data = {}}} = await sensor_summary_generator.next()

              const {summary = {turnOverRate: {}}, daily = [{calculations: {pressureLevel: 0}}]} = data

              this.turnOverRate = {
                retrieved: true,
                ...(summary.pressureLevel || {high: 0, high_date: null, low: 0, low_date: null, avg: 0}),
                current: daily.length !== 0
                    ? String((daily[daily.length - 1]).calculations.pressureLevel) : 0
              }

              this.sensor_data = [
                ['Date', 'Pressure Level'],
                ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                    ({date, calculations = {}}) => [
                      new Date(date), Number(calculations.pressureLevel)
                    ]
                )
              ]
              this.loading = false
            },
            async retrieve_wired_pressure_data_details(){
              this.loading_detail = true
              this.chart_data = null

              if (device_type_enum[this.sensor_type_desc] === Single_Wired_Pressure_Sensor) {
                const sensor_data_generator = get_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  //toDate: adjustDate(this.details_toDate)
                })
                const { value: { data = [] } } = await sensor_data_generator.next()
                if (data[0]) {
                  this.chart_data = [
                    ['Date', 'Pressure', 'Set Pressure'],
                    ...data.map(({date, value, value2}) => [
                      new Date(date),
                      Number(value),
                        Number(value2)
                    ])
                  ]
                }
                this.loading_detail = false
                }
            },
            async retrieve_dual_wired_pressure_data() {
              this.show_chart_data = true

              const sensor_summary_generator = get_sensor_summary(
                  {
                    podId: this.podid,
                    fromDate: justDate(this.fromDate),
                    toDate: justDate(this.toDate)
                  });
              const {value: {data = {}}} = await sensor_summary_generator.next()

              const {summary = {turnOverRate: {}}, daily = [{calculations: {pressureLevel: 0}}]} = data

              this.turnOverRate = {
                retrieved: true,
                ...(summary.pressureLevel || {high: 0, high_date: null, low: 0, low_date: null, avg: 0}),
                current: daily.length !== 0
                    ? String((daily[daily.length - 1]).calculations.pressureLevel) : 0
              }

              this.sensor_data = [
                ['Date', 'Pressure Delta'],
                ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                    ({date, calculations = {}}) => [
                      new Date(date), Number(calculations.pressureLevel)
                    ]
                )
              ]
              this.loading = false
            },
            async retrieve_dual_wired_pressure_data_details(){
              this.loading_detail = true
              this.chart_data = null

              if (device_type_enum[this.sensor_type_desc] === Dual_Wired_Pressure_Sensor) {
                const sensor_data_generator = get_sensor_data({
                  podid: this.podid,
                  fromDate: adjustDate(this.details_fromDate),
                  //toDate: adjustDate(this.details_toDate)
                })
                const { value: { data = [] } } = await sensor_data_generator.next()
                if (data[0]) {
                  this.chart_data = [
                    ['Date', 'Pressure 1', 'Pressure 2', 'Pressure Delta'],
                    ...data.map(({date, value, value2, delta}) => [
                      new Date(date),
                      Number(value),
                      Number(value2),
                      Number(delta)
                    ])
                  ]
                }
                this.loading_detail = false
              }
            },
            async retrieve_meter_dog_data() {

                const sensor_summary_generator = get_sensor_summary(
                    {
                        podId: this.podid,
                        fromDate: justDate(this.fromDate),
                        toDate: justDate(this.toDate)
                    });

                const {value: {data = {}}} = await sensor_summary_generator.next()
                const {summary = {}, daily = []} = data

                //console.log("sensor_data " + JSON.stringify(data));

                if (device_type_enum[this.sensor_type_desc] === Wired_Mag_Field_XYZ) {
                    this.turnOverRate = {
                        retrieved: true,
                        ...summary.waterNumber || {high: 0, high_date: null, low: 0, low_date: null, avg: 0},
                        current: daily.length !== 0
                            ? String(daily[daily.length - 1].calculations.waterNumber) : 0
                    }


                    this.sensor_data = [
                        ['Date', 'WaterNumber'],
                        ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                moment(String(date)).format('MM/DD'), Number(calculations.waterNumber || 0)
                            ]
                        )
                    ]

                    this.loading = false
                } else {

                }
            },
            async retrieve_flow_plot_data() {
                this.loading_detail = true
                this.flow_plot_data = null
                this.show_flow_plot_data = true

                //also get the flow plot data
                const fp_data_generator = get_sensor_flow_plot(
                    {
                        podId: this.podid,
                        fromDate: adjustDate(this.details_fromDate),
                        toDate: adjustDate(this.details_toDate),
                    });

                const { value: { data = [] } } = await fp_data_generator.next()
                if (data.length > 0) {
                    this.flow_plot_data = [
                        ['Date', 'Flow Rate'],
                        ...(data).map(
                            ({date, flowrate = {}}) => [
                                new Date(date),
                                Number(flowrate || 0)
                            ]
                        )
                    ]
                } else {
                    this.flow_plot_data = null
                }

                this.loading_detail = false
            },
            async retrieve_level_smart_data(){

                this.gallons_added_data = null

                const sensor_summary_generator = get_sensor_summary(
                    {
                        podId: this.podid,
                        fromDate: justDate(this.fromDate),
                        toDate: justDate(this.toDate)
                    });
                const {value: {data = {}}} = await sensor_summary_generator.next()

                const {summary = {}, daily = []} = data
                //console.log("sensor_data " + JSON.stringify(data));

                if (device_type_enum[this.sensor_type_desc] === Wireless_Liquid_Level_Sensor) {

                    this.gallons_added_data = [
                        ['Date', 'Times Filled', 'Gallons Added'],
                        ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date),
                                Number(calculations.numberOfFills || 0),
                                Number(calculations.gallonsAdded || 0),
                            ]
                        )
                    ]

                    this.stored_summary = summary
                    this.stored_chartData = daily
                    this.update_summary_units(this.selected_summary_unit)

                    this.water_level_summary_data = [
                        ['Date', 'Water Level' ],
                        ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date),
                                Number(calculations.waterLevelInches || 0),
                            ]
                        )
                    ]

                    this.temperature_summary_data = [
                        ['Date', 'Temperature'],
                        ...(daily.length !== 0 ? daily : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date),
                                Number((calculations.temperatureFahrenheit != 0 ? calculations.temperatureFahrenheit-10 : null) || 0)
                            ]
                        )
                    ]

                    this.loading = false
                }
            },

            update_summary_units(unit){
                if (this.stored_summary) {
                    if (unit == 'inches') {
                        this.dom_values_by_sensor_type.summary_label = 'Inches';
                        this.turnOverRate = {
                            retrieved: true,
                            ...this.stored_summary.waterLevelInches || {high: 0, low: 0, avg: 0},
                            current: this.stored_chartData.length !== 0
                                ? String(this.stored_chartData[this.stored_chartData.length - 1].calculations.waterLevelInches)
                                : 0
                        }

                    } else if (unit == 'fahrenheit') {
                        this.update_temperature_summary()
                        this.dom_values_by_sensor_type.summary_label = 'Fahrenheit';
                        this.turnOverRate = {
                            retrieved: true,
                            ...this.stored_summary.temperatureFahrenheit || {high: 0, low: 0, avg: 0},
                            current: this.stored_chartData.length !== 0
                                ? String((this.stored_chartData[this.stored_chartData.length - 1].calculations.temperatureFahrenheit != 0 ? this.stored_chartData[this.stored_chartData.length - 1].calculations.temperatureFahrenheit-10 : 0))
                                : 0
                        }
                    }
                }
            },
            update_temperature_summary() {
                //console.log("this.stored_summary.temperatureFahrenheit = " + JSON. stringify(this.stored_summary.temperatureFahrenheit))
                if (this.stored_summary.temperatureFahrenheit != null) {
                    if (this.stored_summary.temperatureFahrenheit.high != null) {
                        const high = this.stored_summary.temperatureFahrenheit.high - 10
                        this.stored_summary.temperatureFahrenheit.high = high
                    }
                    if (this.stored_summary.temperatureFahrenheit.low != null) {
                        const low = this.stored_summary.temperatureFahrenheit.low - 10
                        this.stored_summary.temperatureFahrenheit.low = low
                    }
                    if (this.stored_summary.temperatureFahrenheit.avg != null) {
                        const avg = this.stored_summary.temperatureFahrenheit.avg - 10
                        this.stored_summary.temperatureFahrenheit.avg = avg
                    }
                }
            },
            show_update_gpm() {
                this.update_gpm_displayed = true
            },
            async update_gpm(){
                try{
                    this.update_gpm_displayed = false
                    const update_sensor_generator = update_sensor_gpm({
                        podid: this.podid,
                        gpm: this.gpm,
                        account_id: this.userData.accountId
                    })
                    await update_sensor_generator.next()
                } catch(e){
                    this.update_gpm_displayed = false
                }
            },

            async set_lsol_chart_data() {
                this.loading_detail = true
                this.show_lsol_data = true
                this.water_level_detail_data = null
                this.temperator_detail_data = null

                //const hourly_summary_generator = get_hourly_sensor_summary(this.podid)
                const hourly_summary_generator = get_hourly_sensor_summary_bydate({
                        podId: this.podid,
                        fromDate: adjustDate(this.details_fromDate),
                        toDate: adjustDate(this.details_toDate),
                })
                const { value: { data = {} } } = await hourly_summary_generator.next()

                const { summary = {}, hourly = [] } = data
                if (device_type_enum[this.sensor_type_desc] === Wireless_Liquid_Level_Sensor) {
                    this.water_level_detail_data = [
                        ['Date', 'Water Level'],
                        ...(hourly.length !== 0 ? hourly : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date),
                                Number(calculations.waterLevelInches || 0)
                            ]
                        ).filter(function(r) { return Number(r[1]) != 0; })
                    ]
                    if (this.water_level_detail_data.length == 1) {
                      this.water_level_detail_data = null
                    }

                    this.temperature_detail_data = [
                        ['Date', 'Temperature'],
                        ...(hourly.length !== 0 ? hourly : [{date: new Date()}]).map(
                            ({date, calculations = {}}) => [
                                new Date(date),
                                Number((calculations.temperatureFahrenheit != 0 ? calculations.temperatureFahrenheit-10 : null) || 0)
                            ]
                        ).filter(function(r) { return Number(r[1]) != 0; })
                    ]
                  if (this.temperature_detail_data.length == 1) {
                    this.temperature_detail_data = null
                  }


                    this.loading_detail = false
                }
            },
            async shift_detail_graph_date(shift) {
                if (this.resolution == 'daily') {
                  this.details_fromDate = moment(this.details_fromDate, 'MM/DD/YYYY').add(shift, 'days').format('MM/DD/YYYY');
                } else {
                  this.details_fromDate = moment(this.details_fromDate, 'MM/DD/YYYY').add(shift, 'weeks').format('MM/DD/YYYY');
                }
            },
            async update_resolution() {
              if (this.resolution == 'daily') {
                this.resolution = 'weekly'
                this.detail_date_format = 'MM/dd'
                this.details_fromDate = moment(this.details_fromDate, 'MM/DD/YYYY').add(-7, 'days').format('MM/DD/YYYY');
              } else {
                this.resolution = 'daily'
                this.detail_date_format = 'hhaa'
                this.details_fromDate = moment(this.details_toDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
              }
            },
        },
        filters: {
            display_duration: item => compute_alert_duration(item),
            //parse_summary: val => val > 10 ? Math.round(val) : (val < 1 ? val.toString().replace('0.','.') : val),
            parse_summary: val => val > 10 ? Math.round(val) : val,
            display_threshold: ({ alertType, threshold, magZ }) => ({
                'LEAK': `${threshold} hrs`,
                'BATTERY': `${threshold} mV`,
                'LOWFLOW': `${threshold} GPM`,
                'LOWPRESSURE': `${Math.round((magZ/100 + Number(threshold))*10)/10} psi`,
                'LOWLEVEL': `${threshold} in`,
                'HIGHLEVEL': `${threshold} in`
            })[alertType],

            compute_alert_value: ({ alertType, gpm, waterLevelInches, magY, batteryVoltage, threshold }) => ({
                'LEAK': `${threshold} hrs`,
                'BATTERY': `${batteryVoltage } mV`,
                'LOWFLOW': `${gpm} GPM`,
                'LOWPRESSURE': `${magY/100} psi`,
                'LOWLEVEL': `${waterLevelInches} in`,
                'HIGHLEVEL': `${waterLevelInches} in`
            })[alertType]
        },
        watch: {
            details_fromDate(target_from_date) {

                if (this.resolution == 'weekly') {
                  this.details_fromDate = target_from_date
                  this.details_toDate = moment(this.details_fromDate, 'MM/DD/YYYY').add(7, 'days').format('MM/DD/YYYY')
                  this.fromDate = this.details_fromDate
                  this.toDate = this.details_toDate
                  this.update_graphs();
                }

                if (this.resolution == 'daily') {
                  this.loading_detail = true
                  this.details_fromDate = target_from_date
                  this.details_toDate = moment(this.details_fromDate, 'MM/DD/YYYY').add(1, 'days').format('MM/DD/YYYY')
                  if (device_type_enum[this.sensor_type_desc] === FlowVis_Digital) {
                    this.retrieve_flowvis_chart_data()
                  } else if (device_type_enum[this.sensor_type_desc] === Wired_Mag_Field_XYZ) {
                    this.retrieve_flow_plot_data()
                  } else if (device_type_enum[this.sensor_type_desc] === Wireless_Liquid_Level_Sensor) {
                    this.set_lsol_chart_data()
                  } else if (device_type_enum[this.sensor_type_desc] === Single_Wired_Pressure_Sensor) {
                    this.retrieve_wired_pressure_data_details()
                  } else if (device_type_enum[this.sensor_type_desc] === Dual_Wired_Pressure_Sensor) {
                    this.retrieve_dual_wired_pressure_data_details()
                  } else if (device_type_enum[this.sensor_type_desc] === KonaFlow_Digital) {
                    this.set_konaflow_chart_data()
                  } else if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_III) {
                    this.set_cropdr_chart_co2_data()
                    this.set_cropdr_par_chart_data()
                    this.set_cropdr_chart_temperature_data()
                    this.set_cropdr_chart_moisture_data()
                    this.set_cropdr_chart_vpd_data()
                    this.set_cropdr_chart_humidity_data()
                    // this.set_cropdr_chart_vpd_humidity_data()
                } else if (device_type_enum[this.sensor_type_desc] === Grow3D_Sensor_II) {
                    this.set_cropdr_rgbwir_chart_data()
                    this.set_cropdr_chart_temperature_data()
                    this.set_cropdr_chart_moisture_data()
                  }
                }
            },
        }
    }

</script>

<style scoped>
  .white-link {font-size: 22px; font-weight: bold; color: lightgrey !important }
  .gray-link {font-size: 24px; color: lightgrey !important }
</style>




